// extracted by mini-css-extract-plugin
export var container = "ResponseCard-module--container--dd75e";
export var metaRow = "ResponseCard-module--metaRow--c150d";
export var metaRowLabel = "ResponseCard-module--metaRowLabel--a1859";
export var metaRowValueLink = "ResponseCard-module--metaRowValueLink--31bb5";
export var questions = "ResponseCard-module--questions--92acd";
export var questionsAnswer = "ResponseCard-module--questionsAnswer--21b00";
export var questionsLabel = "ResponseCard-module--questionsLabel--b20c3";